import React, { useEffect, useCallback, useState } from 'react';
import './generic-ai-component-change.scss';
import { ReactComponent as TickIcon } from '../../../../icons/tick.svg';
import { ReactComponent as CrossIcon } from '../../../../icons/cross.svg';

interface GenericAIComponentChangeProps {
  onLoad?: () => void;
  onLoadFinished?: () => void;
  onAcceptState: () => void;
  onRestoreState: () => void;
}

const GenericAIComponentChange: React.FC<GenericAIComponentChangeProps> = ({
  onLoad,
  onLoadFinished,
  onAcceptState,
  onRestoreState,
}) => {
  const [isExiting, setIsExiting] = useState(false);
  // Handle component load lifecycle
  useEffect(() => {
    if (onLoad) {
      onLoad();
    }

    // Simulate load finished after a brief moment
    const timer = setTimeout(() => {
      if (onLoadFinished) {
        onLoadFinished();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [onLoad, onLoadFinished]);

  const handleAccept = useCallback(() => {
    setIsExiting(true);
    // Wait for animation to complete before calling handler
    setTimeout(() => {
      onAcceptState();
    }, 200); // Match the animation duration
  }, [onAcceptState]);

  const handleRestore = useCallback(() => {
    setIsExiting(true);
    // Wait for animation to complete before calling handler
    setTimeout(() => {
      onRestoreState();
    }, 200); // Match the animation duration
  }, [onRestoreState]);

  return (
    <div
      className={`generic-ai-component-change${isExiting ? ' exiting' : ''}`}
    >
      <span>Updated by manager, keep changes?</span>
      <div className='ai-actions'>
        <div className='ai-change-action' onClick={handleAccept}>
          <TickIcon />
        </div>
        <div className='ai-change-action' onClick={handleRestore}>
          <CrossIcon />
        </div>
      </div>
    </div>
  );
};

export default GenericAIComponentChange;
